import BlockchainWrap from "./components/BlockchainWrap";
import TextContent from "./components/TextContent";
// import WebSpaceWrap from "./components/WebSpaceWrap";
import MeetsCapitalWrap from "./components/MeetsCapitalWrap";
import PartnersWrap from "./components/PartnersWrap";
import OurMembersWrap from "./components/OurMembersWrap";
import SubscribeWrap from "./components/SubscribeWrap";
// import GalleryWrap from "./components/GalleryWrap";
import WebEventsWrap from "./components/WebEventsWrap";
import ExploreOurOfferWrap from "./components/ExploreOurOfferWrap";
import GoToTopWrap from "./components/GoToTopWrap";
import "./index.scss";

const HomePage = () => {
  return (
    <div className="homePageWrap">
      <BlockchainWrap />
      <TextContent />
      {/* <WebSpaceWrap /> */}
      <MeetsCapitalWrap />
      <PartnersWrap />
      <OurMembersWrap />
      <SubscribeWrap />
      {/* <GalleryWrap /> */}
      <WebEventsWrap />
      <ExploreOurOfferWrap />
      <GoToTopWrap />
    </div>
  );
};

export default HomePage;
